import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'partnerType',
      'customerType',
      'website'
    ]
  },
  {
    isSortable: true,
    field: 'sentimentDate',
    title: 'Sentiment Date',
    show: true,
    width: 172,
    valuesExport: ['sentimentDate']
  },
  {
    isSortable: true,
    field: 'sentiment',
    title: 'Sentiment',
    show: true,
    width: 382,
    valuesExport: ['sentiment']
  },
  {
    isSortable: false,
    field: 'comments',
    title: 'Comments',
    show: true,
    width: 382,
    valuesExport: ['comments']
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 154,
    valuesExport: ['accountManager']
  }
];

export const exportConfigSentiment = {
  exportUrl: '/sentiment/export',
  exportName: 'sentiment',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  sentimentDate: { startDate: null, endDate: null },
  sentiment: [],
  accountManager: []
};

export const defaultNavigation = {
  fieldName: 'sentimentDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
